import {Component, OnDestroy, OnInit} from '@angular/core';
import {NotificationService} from '../../../provider/notification.service';

let OneSignal;

@Component({
  selector: 'kt-home',
  template: '<router-outlet></router-outlet>'
})
export class HomePage implements OnInit, OnDestroy {
  oneSignalId: string;

  constructor(
    private oneSignal: NotificationService) {
    // register translations
  }

  ngOnInit(): void {
    this.getUserID();
  }

  ngOnDestroy() {
  }


  getUserID() {
    OneSignal.getUserId().then((userId) => {
      this.oneSignalId = userId;
      localStorage.setItem('oneSignalId', this.oneSignalId);
      this.oneSignal.oneSignalLogin(JSON.parse(localStorage.getItem('token_form')).token_val);
      console.log(this.oneSignalId);
    });
  }

}
